import React from 'react';
import { Marker } from 'react-map-gl/maplibre';
import { css } from '@emotion/react';

interface MapPinProps {
  latitude: number;
  longitude: number;
  className?: string;
}

const MapMarkerDot: React.FC<MapPinProps> = ({ latitude, longitude, className }) => {
  const markerCss = {
    position: css({
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
    }),
  };
  return (
    <Marker latitude={latitude} longitude={longitude}>
      <div
        className={`maplibregl-user-location-dot maplibregl-marker maplibregl-marker-anchor-center ${className || ''}`}
        aria-label="Map marker"
        css={markerCss.position}
      />
    </Marker>
  );
};

export default MapMarkerDot;
